module.exports = __webpack_public_path__ + "img/right-arm.edfdb841.svg";